function posizioneToLatLng(posizione) {
  return { lat: posizione.latitudine, lng: posizione.longitudine }
}

function latLngToPosizione(latLng) {
  return { latitudine: latLng.lat, longitudine: latLng.lng }
}

export {
  posizioneToLatLng,
  latLngToPosizione,
}